import { DEFAULT_LAYOUT_STYLE } from "./constants/ThemeConstants";

export const THEME_CONFIG = {
	navCollapsed: false,
	dataHover: true,
	topNavCollapsed: true,
	layoutStyle: DEFAULT_LAYOUT_STYLE,
};